import api from "../../client";
import {
  AccountDetailResponseData,
  UpdateAccountPayload,
} from "../../types/account";

export const updateAccountRequest = async (
  uuid: string | undefined,
  payload: UpdateAccountPayload,
): Promise<AccountDetailResponseData> => {
  const { data } = await api.put<AccountDetailResponseData>(
    `/account/${uuid}`,
    payload,
  );

  return data;
};
